import { fetchAuthSession } from '@aws-amplify/auth';
import {
  ApolloClient,
  InMemoryCache,
  ApolloLink,
  HttpLink,
} from '@apollo/client';
import { createAuthLink, AUTH_TYPE } from 'aws-appsync-auth-link';

import infraConfig from '../config.json';

let savedAppSyncClientAudit;

export const AppSyncClientAudit = (user) => {
  if (!user) {
    return undefined;
  }

  if (!savedAppSyncClientAudit) {
    savedAppSyncClientAudit = new ApolloClient({
      cache: new InMemoryCache(),
      link: ApolloLink.from([
        createAuthLink({
          url: infraConfig.appsyncAuditUrl,
          region: infraConfig.region,
          auth: {
            type: AUTH_TYPE.AMAZON_COGNITO_USER_POOLS,
            jwtToken: new Promise((resolve, _reject) => {
              fetchAuthSession().then(
                ({ tokens }) => {
                  console.log('fetchAuthSession() succeeded.');
                  console.log(tokens);
                  if (!tokens || !tokens.accessToken) {
                    // reject(new Error('No access token found'));
                    resolve(undefined);
                  } else {
                    resolve(tokens.accessToken.toString());
                  }
                }
              ).catch((err) => {
                console.log('fetchAuthSession() failed.');
                console.log(err);
                // reject(err);
                resolve(null);
              });
            }),
          },
        }),
        new HttpLink({ uri: infraConfig.appsyncAuditUrl }),
      ]),
    });
  }
  // TODO: keyPrefix: 'audit',

  return savedAppSyncClientAudit;
};

export default {};
